export const menuCreator = function (groups) { 
    var root = [];
    for (var g = 0; g < groups.length; g++) {
        var group = { id: groups[g].Id, title: groups[g].Title, groupPicPath: groups[g].GroupPicPath, items : []};
        for (var s = 0; s < groups[g].SubGroups.length; s++) {
            var newObject = { id: groups[g].SubGroups[s].Id, title: groups[g].SubGroups[s].Title, type: 'SubGroup' };
            group.items.push(newObject);
            for (var c = 0; c < groups[g].SubGroups[s].Categories.length; c++) {
                newObject = { subGroupId: groups[g].SubGroups[s].Id, subGroupName: groups[g].SubGroups[s].Title  , id: groups[g].SubGroups[s].Categories[c].Id, title: groups[g].SubGroups[s].Categories[c].Title, type: 'Category' }
                group.items.push(newObject);
            }
        }
        root.push(group);
    }
    return root;
}